import { ThemeUICSSObject, spacing } from '@apia/theme';

const modal: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  alignItems: 'stretch',
  width: 'min(75vw,600px)',
  maxHeight: '75vh',
  gap: spacing(3),
  overflow: 'hidden',

  '.hierarchicalStructureModalAccordionContainer': {
    background: 'palette.background.paper',
    tr: { gap: spacing(3) },
    overflowY: 'auto',
  },

  '.hierarchicalStructureModalPool': {
    maxHeight: '25vh',
  },

  '.hierarchicalStructureModalEnvironments': {
    maxHeight: '25vh',
    '.tree': {
      height: '100%',
    },
  },

  '.hierarchicalStructureModalUsers': {
    overflow: 'auto',
    p: 0,
    height: '100%',
    thead: {
      tr: {
        position: 'sticky',
        top: 0,
      },
    },
  },
};

export default modal;
